let components = {}

export const addComponents = (newComponents) => {
  components = { ...components, ...newComponents }
}

export const getComponent = name => components[name] || null
